<template>
  <generic-container
    :title="$t('arguments')"
    icon="list"
    :header_buttons="header_buttons"
  >
    <div class="ui form">
      <div class="three fields" v-for="(arg, idx) in args" :key="idx">
        <div class="field">
          <label for="" v-if="idx == 0">{{ $t("name") }} </label>
          <input type="text" v-model="args[idx].name" />
        </div>
        <div class="field">
          <label for="" v-if="idx == 0">{{ $t("value") }} </label>
          <input type="text" v-model="args[idx].value" />
        </div>
        <div class="field">
          <label for="" v-if="idx == 0">{{ $t("options") }} </label>
          <div class="ui basic labeled icon button" @click="remove(idx)">
            <i class="trash red icon"></i> {{ $t("delete") }}
          </div>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";

export default {
  name: "RobotModalArguments",
  components: { GenericContainer },
  props: { robot_in: Object },
  data() {
    return {
      args: [],
      header_buttons: [
        {
          icon: "green plus",
          tooltip: this.$t("add"),
          click: this.add,
        },
      ],
    };
  },
  methods: {
    add() {
      this.args.push({ name: `arg_${this.args.length + 1}`, value: "" });
    },
    remove(index) {
      this.args.splice(index, 1);
    },
    getData() {
      return this.args;
    },
  },
  mounted() {
    if (this.robot_in && this.robot_in.setup && this.robot_in.setup.arguments)
      this.args = this.robot_in.setup.arguments;
  },
};
</script>
